import styled from "styled-components";
import BackgroundImage from "../../Assets/BG.svg";
import BackgroundImage2 from "../../Assets/bg/bottom_every.png";
export const MainWrapper = styled.div`
  width: "100vw";
  background-color: #060310;
`;

export const HeroSectionWrapper = styled.div`
  width: 100%;
  height: fit-content;
  min-height: 100vh;
  padding-top: 100px;
  background: url(${BackgroundImage});
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardWrapper = styled.div`
  width: 300px;
  display: flex;
  justify-content: space-around;
  padding: 20px;
  border-radius: 15px;
  background-color: rgba(229, 229, 229, 0.12);
  backdrop-filter: blur(50px);
  img {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }
`;

export const MoneyImageLogo = styled.img`
  width: 250px;
  height: 250px;
  @media screen and (max-width: 768px) {
    width: 150px;
    height: 150px;
  }
`;


export const BackgroundImageWrapper = styled.div`
  background: url(${BackgroundImage2}) no-repeat;
  background-size: cover;
`;